export function Center({ children }: { children: React.ReactNode }) {
	return (
		<div className="container h-[calc(100vh-57px)] flex items-center justify-center">
			{children}
		</div>
	);
}
